export enum PracticeRole {
  Adviser = "Adviser",
  SupportStaff = "SupportStaff",
  PracticeManager = "PracticeManager",
  Other = "Other",
}
